import { HeartHandshake } from "lucide-react";
import { rupiah } from "@/lib/format";

const fmtDate = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d)) return "";
  const date = d.toLocaleDateString("id-ID", { day: "numeric", month: "short", year: "numeric", timeZone: "Asia/Jakarta" });
  const time = d.toLocaleTimeString("id-ID", { hour: "2-digit", minute: "2-digit", hour12: false, timeZone: "Asia/Jakarta" }).replace(".", ":");
  return `${date}, ${time}`;
};

export const DonorTicker = ({ donors = [] }) => {
  if (donors.length === 0) return null;
  const reps = Math.max(2, Math.ceil(10 / donors.length));
  const items = Array.from({ length: reps }, () => donors).flat();
  return (
    <div className="sticky top-16 z-40 bg-[#d4af37] text-emerald-950 overflow-hidden shadow-md" data-testid="donor-ticker">
      <div className="max-w-7xl mx-auto flex items-stretch">
        <div className="shrink-0 flex items-center gap-2 px-4 py-2 text-xs font-bold uppercase tracking-widest bg-[#c19d2a] whitespace-nowrap" data-testid="donor-ticker-label">
          <HeartHandshake size={14} /> Donasi Terbaru
        </div>
        <div className="flex-1 overflow-hidden flex items-center">
          <div className="marquee-track py-2 text-sm font-medium">
            {items.map((d, i) => {
              const when = fmtDate(d.confirmed_at);
              return (
                <span key={`${d.id}-${i}`} className="px-6 whitespace-nowrap" data-testid={i < donors.length ? `ticker-item-${d.id}` : undefined}>
                  {d.name} — {rupiah(d.amount).replace("Rp ", "Rp")}
                  {when && <span className="opacity-80"> · {when}</span>}
                  <span className="opacity-40 pl-6">|</span>
                </span>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};
